import React from 'react';
import { IconsWrap } from './StyledComponents/StyledComp';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import { SiLeetcode } from 'react-icons/si';

function Links() {
    return (
        <IconsWrap>
            <a href="https://www.linkedin.com/in/devansh-batra-9999a6191/" target='_blank' ><li className="clickable"  ><BsLinkedin size={25} /></li></a>
            <a href="https://github.com/devanshbatra" target='_blank' ><li className="clickable" ><BsGithub size={25} /></li></a>
            <a href="https://leetcode.com/devanshbatra/" target='_blank' ><li className="clickable"  ><SiLeetcode size={25} /></li></a>
        </IconsWrap>
    )
}

export default Links;